import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testnurse2',
  templateUrl: './testnurse2.component.html',
  styleUrls: ['./testnurse2.component.css']
})
export class Testnurse2Component implements OnInit {

  constructor() { }

  ngOnInit() {
    alert('test2');
  }

}
